import { UserProfile } from 'api/profiles'
import { GetIPInfoRes } from 'api/users'
import { RegionToCountriesMap } from 'constants/regions'
import { Region } from 'types'

/**
 * Determines the user's country based on their profile, or, if not authenticated and if possible, based on their IP info.
 * @param userProfile
 * @param ipInfo
 */
export function determineUserCountry(
  userProfile: UserProfile | undefined,
  ipInfo: GetIPInfoRes | undefined
) {
  if (userProfile?.shippingAddress?.country)
    return userProfile.shippingAddress.country

  if (ipInfo?.country) return ipInfo.country

  return 'UK'
}

/**
 * Determines the user's region based on their country.
 * @param userCountry
 */
export function determineUserRegionByCountry(
  userCountry: string | undefined | null
) {
  if (!userCountry) return null

  const _region = Object.keys(RegionToCountriesMap).find(r => {
    const countries = RegionToCountriesMap[r as Region]
    return countries.includes(userCountry)
  })

  if (!_region) return null

  return _region as Region
}

/**
 * Determines the user's region based on their profile, or, if not authenticated and if possible, based on their IP info.
 * @param userProfile
 * @param ipInfo
 */
export function determineUserRegionByProfile(
  userProfile: UserProfile | undefined,
  ipInfo: GetIPInfoRes | undefined
) {
  const userCountry = determineUserCountry(userProfile, ipInfo)

  if (!userCountry) return null

  return determineUserRegionByCountry(userCountry)
}
